import dayjs from 'dayjs'
import type { ReactNode } from 'react'

import { Typography } from '@/src/elements/text/Typography'

import type { TChatMessageProps } from './ChatMessage.types'

type TChatMessageTimestampProps = Pick<TChatMessageProps, 'createdAt'> & {
  color: 'default' | 'white'
}

export const ChatMessageTimestamp = ({ color, createdAt }: TChatMessageTimestampProps): ReactNode => (
  <Typography size="xs" contrast="high" colors={color} className="opacity-60 text-right">
    {dayjs(createdAt).format('HH:mm')}
  </Typography>
)
